import { applicationTypes } from "modules/common/constants";
import React, { useContext } from "react";
import { Filter, ToggleSwitch } from "..";
import { AccessibilityContext } from "views/AccessibilityContext";

interface Props {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onClear: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
    isActive: boolean;
    showDropdown: boolean;
    value: number[];
}

export type PlatformFilterState = string[];

const platformsToRender = [applicationTypes.Web, applicationTypes.Mobile];

export const PlatformFilter: React.FC<Props> = ({
    onChange,
    onClick,
    onClear,
    isActive,
    showDropdown,
    value,
}) => {
    const { lowVision } = useContext(AccessibilityContext);
    return (
        <Filter
            isActive={isActive}
            showDropdown={showDropdown}
            onClear={onClear}
            onClick={onClick}
            text="PLATFORMA"
        >
            {platformsToRender.map(plafrorm => (
                <div key={plafrorm.value}>
                    <ToggleSwitch
                        value={plafrorm.value.toString()}
                        checked={value.includes(plafrorm.value)}
                        onChange={onChange}
                        htmlFor={plafrorm.label}
                        text={
                            <div
                                className={
                                    lowVision ? "low-vision-white-text" : "filter__item__text"
                                }
                            >
                                {plafrorm.label.toLocaleUpperCase()}
                            </div>
                        }
                    />
                </div>
            ))}
        </Filter>
    );
};
